import {createAsyncThunk} from '@reduxjs/toolkit';
import HttpClient from '../../api/api';
import {VisibleDays} from './types';
import {downloadBlob} from './utils';

type DownloadReportArgs = {
    dateFrom: string;
    dateTo: string;
    employeeIds?: number[];
    projectIds?: number[];
    showAbsences?: boolean;
    header?: string;
    searchQuery?: string;
}

type DownloadDetailedReportArgs = DownloadReportArgs & {
    visibleDays?: VisibleDays;
}

const downloadReportFile = async (
    loader: () => Promise<{ data: Blob }>,
    filename: string
) => {
    const response = await loader();
    downloadBlob(response.data, filename);
};

export const downloadTimeReportByEmployee
    = createAsyncThunk<void, DownloadReportArgs>(
        'report/download/time-report-by-employee',
        async ({ dateFrom, dateTo, employeeIds, projectIds, showAbsences, header, searchQuery }) => {
            const filename = `${header ?? 'time-report-by-employee'}_${dateFrom}_${dateTo}.xlsx`;
            await downloadReportFile(
                () => HttpClient.reportApi.downloadTimeReportByEmployee<Blob>(
                    dateFrom, dateTo, employeeIds, projectIds, showAbsences, searchQuery
                ),
                filename
            );
        }
    );

export const downloadTimeReportByProject
    = createAsyncThunk<void, DownloadReportArgs>(
        'report/download/time-report-by-project',
        async ({ dateFrom, dateTo, employeeIds, projectIds, showAbsences, header, searchQuery }) => {
            const filename = `${header ?? 'time-report-by-project'}_${dateFrom}_${dateTo}.xlsx`;
            await downloadReportFile(
                () => HttpClient.reportApi.downloadTimeReportByProject<Blob>(
                    dateFrom, dateTo, employeeIds, projectIds, showAbsences, searchQuery
                ),
                filename
            );
        }
    );

export const downloadTimeReportByEmployeeDaily
    = createAsyncThunk<void, DownloadDetailedReportArgs>(
        'report/download/time-report-by-employee-daily',
        async ({ dateFrom, dateTo, employeeIds, projectIds, showAbsences, visibleDays, header, searchQuery }) => {
            const filename = `${header ?? 'time-report-by-employee-daily'}_${dateFrom}_${dateTo}.xlsx`;
            await downloadReportFile(
                () => HttpClient.reportApi.downloadTimeReportByEmployeeDaily<Blob>(
                    dateFrom, dateTo, employeeIds, projectIds, showAbsences, visibleDays, searchQuery
                ),
                filename
            );
        }
    );

export const downloadTimeReportByProjectDaily
    = createAsyncThunk<void, DownloadDetailedReportArgs>(
        'report/download/time-report-by-project-daily',
        async ({ dateFrom, dateTo, employeeIds, projectIds, showAbsences, visibleDays, header, searchQuery }) => {
            const filename = `${header ?? 'time-report-by-project-daily'}_${dateFrom}_${dateTo}.xlsx`;
            await downloadReportFile(
                () => HttpClient.reportApi.downloadTimeReportByProjectDaily<Blob>(
                    dateFrom, dateTo, employeeIds, projectIds, showAbsences, visibleDays, searchQuery
                ),
                filename
            );
        }
    );
